import { render, staticRenderFns } from "./BackupsTab.vue?vue&type=template&id=4b21733e&"
import script from "./BackupsTab.vue?vue&type=script&lang=js&"
export * from "./BackupsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports